import ProfileBasicVO from './ProfileBasicVO';
import { VerificationType } from '@domain/constant/verificationType';

export const selectOptionText = {
  NEW: '신입으로 입사 준비중',
  CAREER: '경력으로 입사 준비중',
};

export class ProfileBasicFormVO {
  name: string | null;
  profileImageUid: string | null;
  birthDate: string | null;
  countryCode: string | null;
  mobile: string | null;
  email: string;
  token: string; //휴대폰 인증 토큰
  userIdentificationType: VerificationType | null;
  identified: boolean | null;

  constructor(vo: ProfileBasicVO) {
    this.name = vo.name;
    this.profileImageUid = vo.profileImageUid;
    this.birthDate = vo.birthDate;
    this.countryCode = vo.countryCode;
    this.mobile = vo.mobileText;
    this.email = vo.email || '';
    this.token = '';
    this.userIdentificationType = vo.userIdentificationType;
    this.identified = vo.identified;
  }
}
